import { Sun, BatteryMedium, UtilityPole, Building2 } from "lucide-react";
import { Section, stagger, slug } from "./Section";

const STATS = [
  ["500+ MW", "Supported through Owner's Engineer and construction quality assurance assignments"],
  ["400+ MW", "Supported through grid connection assessments"],
  ["10+ Projects", "Across project development and execution"],
  ["180+ Years", "Combined senior project experience across the team"],
];

const CLIENTS = [
  "Asian Development Bank (ADB)",
  "Alsons Power Group",
  "Arbutus Consultants",
  "Black & Veatch",
  "Citicore",
  "Levanta Renewables",
  "Security Bank",
  "Yanara",
];

export const TrackRecord = () => (
  <Section id="track-record" className="relative overflow-hidden bg-[#1B3A6B] text-white" testId="track-record-section">
    <span aria-hidden="true" className="pointer-events-none absolute right-0 top-1/2 hidden -translate-y-1/2 select-none whitespace-nowrap text-[160px] font-bold leading-none text-white/[0.03] md:block lg:text-[240px]" data-testid="track-record-watermark">ALS</span>
    <div className="relative">
      <h2 className="als-heading is-centered is-light text-center" data-testid="section-heading-track-record">Experience where projects are actually delivered</h2>
      <div className="mt-8 grid divide-y divide-white/[0.12] sm:grid-cols-2 sm:divide-x sm:divide-y-0 lg:grid-cols-4" data-testid="track-record-stats">
        {STATS.map(([v, c], i) => {
          const [num, unit] = v.split(" ");
          return (
            <div key={v} className="reveal-item px-6 py-10 lg:px-8 lg:py-12" style={stagger(i)} data-testid={`stat-${slug(v)}`}>
              <p className="text-[40px] font-semibold leading-none tracking-[-0.03em] text-white lg:text-[44px]">{num}</p>
              <p className="mt-1 text-[22px] font-medium leading-tight text-white">{unit}</p>
              <p className="mt-3 text-[15px] leading-[1.6] text-white/75">{c}</p>
            </div>
          );
        })}
      </div>
    </div>
  </Section>
);

export const Clients = () => (
  <Section id="clients" className="relative overflow-hidden bg-[#1B3A6B] text-white" testId="clients-section">
    <h2 className="als-heading is-centered is-light text-center" data-testid="section-heading-clients">Clients</h2>
    <ul className="mx-auto mt-10 grid max-w-[1080px] grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="clients-row">
      {CLIENTS.map((c, i) => (
        <li key={c} className="client-pill reveal-item" style={stagger(i % 4)} data-testid={`client-${slug(c)}`}>{c}</li>
      ))}
    </ul>
  </Section>
);

const SECTORS = [
  [Sun, "Solar PV"],
  [BatteryMedium, "Battery Energy Storage Systems"],
  [UtilityPole, "Substations & Grid Infrastructure"],
  [Building2, "Energy & Infrastructure"],
];

export const Sectors = () => (
  <Section id="sectors" className="bg-white" testId="sectors-section">
    <h2 className="als-heading is-centered text-center" data-testid="section-heading-sectors">Our sectors</h2>
    <ul className="mx-auto mt-8 grid max-w-4xl gap-x-10 sm:grid-cols-2 lg:grid-cols-4" data-testid="sectors-list">
      {SECTORS.map(([Icon, label], i) => (
        <li key={label} className="sector-item reveal-item flex flex-col items-center text-center" style={stagger(i)} data-testid={`sector-${slug(label)}`}>
          <Icon size={32} strokeWidth={1.5} className="mb-3 text-[#1B3A6B]" aria-hidden="true" />
          <span>{label}</span>
        </li>
      ))}
    </ul>
  </Section>
);
